import { render, staticRenderFns } from "./WorldClassReport.vue?vue&type=template&id=27b3df12"
import script from "./WorldClassReport.vue?vue&type=script&lang=js"
export * from "./WorldClassReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports